import { FieldTypes } from '../constants'
import { DropdownField, DropdownOptionItem } from '../types'

export const raceOptions: DropdownOptionItem[] = [
  { id: '00', text: 'Unspecified' },
  { id: '01', text: 'American Indian/Alaska Native' },
  { id: '02', text: 'Asian' },
  { id: '03', text: 'Black or African American, not of Hispanic origin' },
  { id: '04', text: 'Hispanic' },
  { id: '05', text: 'White, not of Hispanic origin' },
  { id: '06', text: 'Native Hawaiian/Other Pacific Islander' },
]

export const raceField: DropdownField = {
  type: FieldTypes.DROPDOWN,
  placeholder: 'Race',
  options: raceOptions,
}

export const ethnicityOptions: DropdownOptionItem[] = [
  { id: 'afghan', text: 'Afghan' },
  { id: 'albanian', text: 'Albanian' },
  { id: 'algerian', text: 'Algerian' },
  { id: 'american', text: 'American' },
  { id: 'andorran', text: 'Andorran' },
  { id: 'angolan', text: 'Angolan' },
  { id: 'anguillan', text: 'Anguillan' },
  { id: 'argentine', text: 'Argentine' },
  { id: 'armenian', text: 'Armenian' },
  { id: 'australian', text: 'Australian' },
  { id: 'austrian', text: 'Austrian' },
  { id: 'azerbaijani', text: 'Azerbaijani' },
  { id: 'bahamian', text: 'Bahamian' },
  { id: 'bahraini', text: 'Bahraini' },
  { id: 'bangladeshi', text: 'Bangladeshi' },
  { id: 'barbadian', text: 'Barbadian' },
  { id: 'belarusian', text: 'Belarusian' },
  { id: 'belgian', text: 'Belgian' },
  { id: 'belizean', text: 'Belizean' },
  { id: 'beninese', text: 'Beninese' },
  { id: 'bermudian', text: 'Bermudian' },
  { id: 'bhutanese', text: 'Bhutanese' },
  { id: 'bolivian', text: 'Bolivian' },
  { id: 'botswanan', text: 'Botswanan' },
  { id: 'brazilian', text: 'Brazilian' },
  { id: 'british', text: 'British' },
  { id: 'british-virgin-islander', text: 'British Virgin Islander' },
  { id: 'bruneian', text: 'Bruneian' },
  { id: 'bulgarian', text: 'Bulgarian' },
  { id: 'burkinan', text: 'Burkinan' },
  { id: 'burmese', text: 'Burmese' },
  { id: 'burundian', text: 'Burundian' },
  { id: 'cambodian', text: 'Cambodian' },
  { id: 'cameroonian', text: 'Cameroonian' },
  { id: 'canadian', text: 'Canadian' },
  { id: 'cape-verdean', text: 'Cape Verdean' },
  { id: 'cayman-islander', text: 'Cayman Islander' },
  { id: 'central-african', text: 'Central African' },
  { id: 'chadian', text: 'Chadian' },
  { id: 'chilean', text: 'Chilean' },
  { id: 'chinese', text: 'Chinese' },
  { id: 'colombian', text: 'Colombian' },
  { id: 'comoran', text: 'Comoran' },
  { id: 'congolese', text: 'Congolese' },
  { id: 'cook-islander', text: 'Cook Islander' },
  { id: 'costa-rican', text: 'Costa Rican' },
  { id: 'croatian', text: 'Croatian' },
  { id: 'cuban', text: 'Cuban' },
  { id: 'cymraes', text: 'Cymraes' },
  { id: 'cymro', text: 'Cymro' },
  { id: 'cypriot', text: 'Cypriot' },
  { id: 'czech', text: 'Czech' },
  { id: 'danish', text: 'Danish' },
  { id: 'djiboutian', text: 'Djiboutian' },
  { id: 'dominican', text: 'Dominican' },
  { id: 'dutch', text: 'Dutch' },
  { id: 'east-timorese', text: 'East Timorese' },
  { id: 'ecuadorean', text: 'Ecuadorean' },
  { id: 'egyptian', text: 'Egyptian' },
  { id: 'emirati', text: 'Emirati' },
  { id: 'english', text: 'English' },
  { id: 'equatorial-guinean', text: 'Equatorial Guinean' },
  { id: 'eritrean', text: 'Eritrean' },
  { id: 'estonian', text: 'Estonian' },
  { id: 'ethiopian', text: 'Ethiopian' },
  { id: 'faroese', text: 'Faroese' },
  { id: 'fijian', text: 'Fijian' },
  { id: 'filipino', text: 'Filipino' },
  { id: 'finnish', text: 'Finnish' },
  { id: 'french', text: 'French' },
  { id: 'gabonese', text: 'Gabonese' },
  { id: 'gambian', text: 'Gambian' },
  { id: 'georgian', text: 'Georgian' },
  { id: 'german', text: 'German' },
  { id: 'ghanaian', text: 'Ghanaian' },
  { id: 'gibraltarian', text: 'Gibraltarian' },
  { id: 'greek', text: 'Greek' },
  { id: 'greenlandic', text: 'Greenlandic' },
  { id: 'grenadian', text: 'Grenadian' },
  { id: 'guamanian', text: 'Guamanian' },
  { id: 'guatemalan', text: 'Guatemalan' },
  { id: 'guinean', text: 'Guinean' },
  { id: 'guinea-bissauan', text: 'Guinea-Bissauan' },
  { id: 'guyanese', text: 'Guyanese' },
  { id: 'haitian', text: 'Haitian' },
  { id: 'honduran', text: 'Honduran' },
  { id: 'hong-konger', text: 'Hong Konger' },
  { id: 'hungarian', text: 'Hungarian' },
  { id: 'icelander', text: 'Icelander' },
  { id: 'indian', text: 'Indian' },
  { id: 'indonesian', text: 'Indonesian' },
  { id: 'iranian', text: 'Iranian' },
  { id: 'iraqi', text: 'Iraqi' },
  { id: 'irish', text: 'Irish' },
  { id: 'israeli', text: 'Israeli' },
  { id: 'italian', text: 'Italian' },
  { id: 'ivorian', text: 'Ivorian' },
  { id: 'jamaican', text: 'Jamaican' },
  { id: 'japanese', text: 'Japanese' },
  { id: 'jordanian', text: 'Jordanian' },
  { id: 'kazakh', text: 'Kazakh' },
  { id: 'kenyan', text: 'Kenyan' },
  { id: 'kittitian', text: 'Kittitian' },
  { id: 'kosovan', text: 'Kosovan' },
  { id: 'kuwaiti', text: 'Kuwaiti' },
  { id: 'kyrgyz', text: 'Kyrgyz' },
  { id: 'lao', text: 'Lao' },
  { id: 'latvian', text: 'Latvian' },
  { id: 'lebanese', text: 'Lebanese' },
  { id: 'liberian', text: 'Liberian' },
  { id: 'libyan', text: 'Libyan' },
  { id: 'liechtensteiner', text: 'Liechtensteiner' },
  { id: 'lithuanian', text: 'Lithuanian' },
  { id: 'luxembourger', text: 'Luxembourger' },
  { id: 'macanese', text: 'Macanese' },
  { id: 'macedonian', text: 'Macedonian' },
  { id: 'malagasy', text: 'Malagasy' },
  { id: 'malawian', text: 'Malawian' },
  { id: 'malaysian', text: 'Malaysian' },
  { id: 'maldivian', text: 'Maldivian' },
  { id: 'malian', text: 'Malian' },
  { id: 'maltese', text: 'Maltese' },
  { id: 'marshallese', text: 'Marshallese' },
  { id: 'martiniquais', text: 'Martiniquais' },
  { id: 'mauritanian', text: 'Mauritanian' },
  { id: 'mauritian', text: 'Mauritian' },
  { id: 'mexican', text: 'Mexican' },
  { id: 'micronesian', text: 'Micronesian' },
  { id: 'moldovan', text: 'Moldovan' },
  { id: 'monacan', text: 'Monacan' },
  { id: 'mongolian', text: 'Mongolian' },
  { id: 'montenegrin', text: 'Montenegrin' },
  { id: 'montserratian', text: 'Montserratian' },
  { id: 'moroccan', text: 'Moroccan' },
  { id: 'mozambican', text: 'Mozambican' },
  { id: 'namibian', text: 'Namibian' },
  { id: 'nauruan', text: 'Nauruan' },
  { id: 'nepalese', text: 'Nepalese' },
  { id: 'new-zealander', text: 'New Zealander' },
  { id: 'nicaraguan', text: 'Nicaraguan' },
  { id: 'nigerien', text: 'Nigerien' },
  { id: 'nigerian', text: 'Nigerian' },
  { id: 'niuean', text: 'Niuean' },
  { id: 'north-korean', text: 'North Korean' },
  { id: 'northern-irish', text: 'Northern Irish' },
  { id: 'norwegian', text: 'Norwegian' },
  { id: 'omani', text: 'Omani' },
  { id: 'pakistani', text: 'Pakistani' },
  { id: 'palauan', text: 'Palauan' },
  { id: 'palestinian', text: 'Palestinian' },
  { id: 'panamanian', text: 'Panamanian' },
  { id: 'papua-new-guinean', text: 'Papua New Guinean' },
  { id: 'paraguayan', text: 'Paraguayan' },
  { id: 'peruvian', text: 'Peruvian' },
  { id: 'pitcairn-islander', text: 'Pitcairn Islander' },
  { id: 'polish', text: 'Polish' },
  { id: 'portuguese', text: 'Portuguese' },
  { id: 'prydeinig', text: 'Prydeinig' },
  { id: 'puerto-rican', text: 'Puerto Rican' },
  { id: 'qatari', text: 'Qatari' },
  { id: 'romanian', text: 'Romanian' },
  { id: 'russian', text: 'Russian' },
  { id: 'rwandan', text: 'Rwandan' },
  { id: 'saint-helenian', text: 'Saint Helenian' },
  { id: 'saint-lucian', text: 'Saint Lucian' },
  { id: 'saint-vincentian', text: 'Saint Vincentian' },
  { id: 'samoan', text: 'Samoan' },
  { id: 'sammarinese', text: 'Sammarinese' },
  { id: 'sao-tomean', text: 'Sao Tomean' },
  { id: 'saudi', text: 'Saudi' },
  { id: 'scottish', text: 'Scottish' },
  { id: 'senegalese', text: 'Senegalese' },
  { id: 'serbian', text: 'Serbian' },
  { id: 'seychellois', text: 'Seychellois' },
  { id: 'sierra-leonean', text: 'Sierra Leonean' },
  { id: 'singaporean', text: 'Singaporean' },
  { id: 'slovak', text: 'Slovak' },
  { id: 'slovenian', text: 'Slovenian' },
  { id: 'solomon-islander', text: 'Solomon Islander' },
  { id: 'somali', text: 'Somali' },
  { id: 'south-african', text: 'South African' },
  { id: 'south-korean', text: 'South Korean' },
  { id: 'south-sudanese', text: 'South Sudanese' },
  { id: 'spanish', text: 'Spanish' },
  { id: 'sri-lankan', text: 'Sri Lankan' },
  { id: 'sudanese', text: 'Sudanese' },
  { id: 'surinamese', text: 'Surinamese' },
  { id: 'swazi', text: 'Swazi' },
  { id: 'swedish', text: 'Swedish' },
  { id: 'swiss', text: 'Swiss' },
  { id: 'syrian', text: 'Syrian' },
  { id: 'taiwanese', text: 'Taiwanese' },
  { id: 'tajik', text: 'Tajik' },
  { id: 'tanzanian', text: 'Tanzanian' },
  { id: 'thai', text: 'Thai' },
  { id: 'togolese', text: 'Togolese' },
  { id: 'tongan', text: 'Tongan' },
  { id: 'trinidadian', text: 'Trinidadian' },
  { id: 'tristanian', text: 'Tristanian' },
  { id: 'tunisian', text: 'Tunisian' },
  { id: 'turkish', text: 'Turkish' },
  { id: 'turkmen', text: 'Turkmen' },
  { id: 'turks-and-caicos-islander', text: 'Turks and Caicos Islander' },
  { id: 'tuvaluan', text: 'Tuvaluan' },
  { id: 'ugandan', text: 'Ugandan' },
  { id: 'ukrainian', text: 'Ukrainian' },
  { id: 'uruguayan', text: 'Uruguayan' },
  { id: 'uzbek', text: 'Uzbek' },
  { id: 'vatican-citizen', text: 'Vatican citizen' },
  { id: 'venezuelan', text: 'Venezuelan' },
  { id: 'vietnamese', text: 'Vietnamese' },
  { id: 'vincentian', text: 'Vincentian' },
  { id: 'wallisian', text: 'Wallisian' },
  { id: 'welsh', text: 'Welsh' },
  { id: 'yemeni', text: 'Yemeni' },
  { id: 'zambian', text: 'Zambian' },
  { id: 'zimbabwean', text: 'Zimbabwean' },
]

export const ethnicityField: DropdownField = {
  type: FieldTypes.DROPDOWN,
  placeholder: 'Ethnicity / Nationality',
  searchable: true,
  options: ethnicityOptions,
}
